export function getCleanUpScheduler(scheduler: string) {
  if (scheduler === 'DPM++SDEKarras') {
    return 'karras';
  }
  return scheduler;
}
